import { createColorGenerator } from "./color-generator.js";
const colorGenerator = createColorGenerator();
class WrappedModel {
    model;
    constructor(model) {
        this.model = model;
    }
    addVisualNode(entity) {
        return this.model.addVisualNode(entity);
    }
    addVisualDiagramNode(entity) {
        return this.model.addVisualDiagramNode(entity);
    }
    addVisualRelationship(entity) {
        return this.model.addVisualRelationship(entity);
    }
    addVisualProfileRelationship(entity) {
        return this.model.addVisualProfileRelationship(entity);
    }
    addVisualGroup(entity) {
        return this.model.addVisualGroup(entity);
    }
    updateVisualEntity(identifier, entity) {
        this.model.updateVisualEntity(identifier, entity);
    }
    deleteVisualEntity(identifier) {
        this.model.deleteVisualEntity(identifier);
    }
    setModelColor(identifier, color) {
        this.model.setModelColor(identifier, color);
    }
    deleteModelColor(identifier) {
        this.model.deleteModelColor(identifier);
    }
    deleteModelData(identifier) {
        this.model.deleteModelData(identifier);
    }
    setView(view) {
        this.model.setView(view);
    }
    getIdentifier() {
        return this.model.getIdentifier();
    }
    getVisualEntity(identifier) {
        return this.model.getVisualEntity(identifier);
    }
    getVisualEntitiesForRepresented(represented) {
        return this.model.getVisualEntitiesForRepresented(represented);
    }
    hasVisualEntityForRepresented(represented) {
        return this.model.hasVisualEntityForRepresented(represented);
    }
    getVisualEntities() {
        return this.model.getVisualEntities();
    }
    subscribeToChanges(listener) {
        return this.model.subscribeToChanges(listener);
    }
    getModelColor(identifier) {
        const stored = this.model.getModelColor(identifier);
        if (stored === null) {
            return colorGenerator.generateModelColor(identifier);
        }
        else {
            return stored;
        }
    }
    getModelsData() {
        return this.model.getModelsData();
    }
    getInitialModelVersion() {
        return this.model.getInitialModelVersion();
    }
    getTypes() {
        return this.model.getTypes();
    }
    getId() {
        return this.model.getIdentifier();
    }
    serializeModel() {
        return this.model.serializeModel();
    }
    deserializeModel(value) {
        this.model.deserializeModel(value);
        return this;
    }
    getLabel() {
        return this.model.getLabel();
    }
    setLabel(label) {
        this.model.setLabel(label);
    }
}
/**
 * Add {@link ColorGenerator} to {@link WritableVisualModel} to generate
 * missing model colors.
 */
export function wrapWithColorGenerator(visualModel) {
    return new WrappedModel(visualModel);
}
//# sourceMappingURL=color-generator-wrap.js.map